module.exports = __webpack_public_path__ + "img/l4.b2913a19.png";